import React from 'react';
import { useTranslation } from 'react-i18next';

import { FlexLayout } from '@swyftx/aviary/atoms/Layout/Flex';
import { Body } from '@swyftx/aviary/atoms/Typography';
import { EnhancedTooltip } from '@swyftx/aviary/molecules/EnhancedTooltip/EnhancedTooltip';
import { MarginOrderType } from '@swyftx/margin/build/types';

import { useMarginTradePanelStore } from 'src/lib/margin/hooks/trade';

const MarginTradePanelMarginExpiry: React.FC = () => {
  const { tradeType } = useMarginTradePanelStore();
  const { t } = useTranslation('margin');

  if (tradeType === MarginOrderType.Market) return null;

  return (
    <FlexLayout alignItems='center' justifyContent='space-between' className='w-full'>
      <EnhancedTooltip title={t('position.expiry.tooltip')} name={t('position.expiry.name')} side='left'>
        <Body color='secondary' underline='dashed' className='cursor-pointer'>
          {t('position.expiry.title')}
        </Body>
      </EnhancedTooltip>
      <Body weight='bold'>{t('tradeReview.gtc')}</Body>
    </FlexLayout>
  );
};

export { MarginTradePanelMarginExpiry };
